// extracted by mini-css-extract-plugin
export default {"container":"SelectTeethFormulaNumbering_container__9CRqE","formItem":"SelectTeethFormulaNumbering_formItem__7JqKO"};